<template>
  <div class="main-content-container container-fluid h-100 px-4">
    <d-row no-gutters class="h-100">
      <d-col lg="3" md="5" class="auth-form mx-auto my-auto">
        <d-card>
          <d-card-body>
            <!-- Logo -->
            <img
              class="d-table mx-auto mb-3 img-fluid"
              src="@/assets/images/login.png"
              alt="Omja Software - Login"
            />

            <!-- Title -->
            <h5 class="auth-form__title text-center mb-4">
              {{ $t("login.title") }}
            </h5>

            <!-- Form Fields -->
            <d-form @submit.prevent="onSubmit">
              <div class="form-group">
                <label for="email">{{ $t("user.email") }}</label>
                <d-input
                  type="email"
                  id="email"
                  :state="errors['email'] === undefined ? null : false"
                  :placeholder="$t('user.your.email')"
                  v-model="model.email"
                />
                <errors :errors="errors" field="email" />
              </div>
              <div class="form-group">
                <label for="password">{{ $t("user.password") }}</label>
                <d-input-group :append="whichIcon" class="mb-2">
                  <d-input
                    :type="passwordType"
                    id="password"
                    :state="errors['password'] === undefined ? null : false"
                    :placeholder="$t('user.password')"
                    v-model="model.password"
                  />
                </d-input-group>
                <errors :errors="errors" field="password" />
              </div>
              <d-button pill type="submit" class="btn-accent d-table mx-auto">{{
                $t("login.connection")
              }}</d-button>
            </d-form>
          </d-card-body>
        </d-card>

        <!-- Meta Details -->
        <div class="auth-form__meta d-flex mt-4">
          <d-link tag="a" :to="{ name: 'forgot-password' }">{{
            $t("login.forgot.password.question")
          }}</d-link>
        </div>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import Errors from '../components/error/errors.vue';
import ErrorsHelper from '../helper/ErrorsHelper';

export default {
  name: 'login',
  components: { Errors },
  data() {
    return {
      model: {
        email: '',
        password: '',
      },
      eyeIcon: 'fas fa-eye-slash',
      passwordType: 'password',
      requiredFields: ['email', 'password'],
      errors: {},
    };
  },

  mounted() {
    this.$store.commit('logoutUser');
  },

  computed: {
    whichIcon() {
      return `<i  class="eye-icon ${
        this.eyeIcon
      }" @click=${this.passwordShowHide()}></i>`;
    },
  },

  methods: {
    onSubmit() {
      this.errors = {};
      if (
        ErrorsHelper.checkErrors(this.requiredFields, this.model, this.errors)
      ) {
        this.$services.user
          .login(this.model.email.toLowerCase(), this.model.password)
          .then(() => {
            this.$router.push('/');
          })
          .catch((error) => {
            console.warn('error', error);
          });
      }
    },

    async passwordShowHide() {
      const v = await document.getElementsByClassName('eye-icon');
      v[0].onclick = () => {
        if (this.passwordType === 'password') {
          this.passwordType = 'text';
          this.eyeIcon = 'fas fa-eye';
        } else {
          this.passwordType = 'password';
          this.eyeIcon = 'fas fa-eye-slash';
        }
      };
    },
  },
};
</script>
